import React, { useState } from 'react';
import Axios from "axios";
import Swal from 'sweetalert2';
//import Swal from '@sweetalert2/theme-bootstrap-4'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Copyright, AddSession } from '../Layout/function';
import Spinner from "../Layout/Spinner";

import './Signin.css';

const theme = createTheme();

async function loginUser(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(process.env.REACT_APP_BACKEND_DOMAIN_API + '/login',
      payload, {
      headers: {
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY
      }
    });
    return result.data;
  } catch (error) {
    return { message: "Your email or password are incorrect" };
  }
}

export default function Signin() {

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    const res = await loginUser({
      email: username,
      password: password
    });
    const response = res.data || {};

    if (response.access_token) {
      Swal.fire({
        icon: 'success',
        title: 'Login Success',
        text: 'Welcome : '+response.first_name,
        showConfirmButton: false,
        timer: 2000
      }).then(async (value) => {
        setIsLoading(false);
        const user = {
          id: response.id,
          accessToken: response.access_token,
          name: response.first_name+' '+response.last_name,
          role: response.role,
          email: response.email
        };
        await AddSession(user);
        window.location.href = "/cms-catalogs";
      });
    } else {
      setIsLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: res.message || 'Your email or password are incorrect',
      });
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
          CMS BigC Online Catalogs
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={e => setUserName(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In {isLoading ? <Spinner /> : ''}
            </Button>
            
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}